/**
 * Globally registers all .vue components inside all sub-directories
 * Ignores files containing '_' which are tightly coupled child components
 *
 * In the markup you invoke them by `<path-file-name />`
 * e.g. /core/Toolbar.vue -> <core-toolbar />
 * e.g. /helpers/PageHeader.vue -> <helpers-page-header />
 */

import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const requireComponent = require.context(
  '@/components', true, /^[^_]*\.vue$/
)

// Dynamically load all components
// and lazily load them
// https://vuejs.org/v2/guide/components-dynamic-async
requireComponent.keys().forEach(fileName => {
  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
  )

  Vue.component(componentName, resolve => {
    const componentConfig = requireComponent(fileName)

    resolve(componentConfig.default || componentConfig)
  })
})
